import React, { useRef, useEffect, useState } from 'react';
import purple from './toyota_newsroom.jpg'
import { useMobileBreakpoint } from '../breakpoints';
import { Wrapper, CardWrapper, MediaImg, MediaContent, Title, Description, Link, ExternalLink, LinkIcon } from './index.styled';
import Fade from 'react-reveal/Fade';
import { MobileCard } from './components/MobileCard';
import externalLink from '../../icons/external_link.svg';
import { useTranslation } from 'react-i18next';

const CONTENT = 'HomePage.ToyotaMedia';

export const ToyotaMedia = ({ home = false }) => {
  const isMobile = useMobileBreakpoint();
  const { t } = useTranslation();
  const cardRef = useRef(null);
  const imgRef = useRef(null);
  const contentRef = useRef(null);
  const [isHome, setIsHome] = useState(home);

  useEffect(() => {
    if (home && cardRef.current) {
      cardRef.current.insertBefore(contentRef.current, imgRef.current);
      setIsHome(true);
    }
  }, [home, isHome])

  return (
    <Fade up>
      <Wrapper id='newsroom' isHome={isHome}>
        {
          isMobile ? (
            <MobileCard isHome={true} image={purple} />
          ) :
            (
              <CardWrapper ref={cardRef}>
                <MediaImg ref={imgRef}>
                  <img src={purple} alt='' role='presentation' />
                </MediaImg>
                <MediaContent isHome={isHome} ref={contentRef}>
                  <Title>{t(`${CONTENT}.title`)}</Title>
                  <Description>{t(`${CONTENT}.description`)}</Description>
                  <ExternalLink>
                    <Link href={t(`${CONTENT}.url`)}>{t(`${CONTENT}.cta`)}</Link>
                    <LinkIcon>
                      <img src={externalLink} height='13px' width='13px' alt='' role='presentation' />
                    </LinkIcon>
                  </ExternalLink>
                </MediaContent>
              </CardWrapper>
            )
        }
      </Wrapper>
    </Fade>
  )
}